import { render, staticRenderFns } from "./CeppBtn.vue?vue&type=template&id=52e45d76&scoped=true&"
import script from "./CeppBtn.vue?vue&type=script&lang=js&"
export * from "./CeppBtn.vue?vue&type=script&lang=js&"
import style0 from "./CeppBtn.vue?vue&type=style&index=0&id=52e45d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e45d76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VBtn,VHover})
